import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { I18nProvider } from "./contexts/I18nContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import { ConsentProvider } from "./contexts/ConsentContext";
import { ComparisonProvider } from "./contexts/ComparisonContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import CarDetails from "./pages/CarDetails";
import Login from "./pages/Login";
import AdminDashboard from "./pages/admin/AdminDashboard";
import OwnerDashboard from "./pages/owner/OwnerDashboard";
import ReviewSubmit from "./pages/ReviewSubmit";
import PublicReviews from "./pages/PublicReviews";
import Offers from "./pages/Offers";
import About from "./pages/About";
import Comparator from "./pages/Comparator";
import LegalPage from "./pages/LegalPage";
import { PayStart, PaySuccess, PayCancel } from "./pages/Pay";
import FloatingContact from "./components/FloatingContact";
import PromoBanner from "./components/PromoBanner";
import CookieBanner from "./components/CookieBanner";
import ComparisonBar from "./components/ComparisonBar";
import SeoTrackers from "./components/SeoTrackers";
import { useSettings } from "./contexts/SettingsContext";

function TrackersHost() {
  const { settings } = useSettings();
  return <SeoTrackers seo={settings?.seo} />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SettingsProvider>
          <ConsentProvider>
            <I18nProvider>
              <AuthProvider>
                <ComparisonProvider>
                  <PromoBanner />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/cars/:id" element={<CarDetails />} />
                    <Route path="/reviews" element={<PublicReviews />} />
                    <Route path="/oferte" element={<Offers />} />
                    <Route path="/despre" element={<About />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/comparator" element={<Comparator />} />
                    <Route path="/termeni" element={<LegalPage kind="terms" />} />
                    <Route path="/confidentialitate" element={<LegalPage kind="privacy" />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/review/:token" element={<ReviewSubmit />} />
                    <Route path="/pay/:id" element={<PayStart />} />
                    <Route path="/pay/success" element={<PaySuccess />} />
                    <Route path="/pay/cancel" element={<PayCancel />} />
                    <Route
                      path="/admin/*"
                      element={
                        <ProtectedRoute role="admin">
                          <AdminDashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/owner/*"
                      element={
                        <ProtectedRoute role="owner">
                          <OwnerDashboard />
                        </ProtectedRoute>
                      }
                    />
                  </Routes>
                  <FloatingContact />
                  <ComparisonBar />
                  <CookieBanner />
                  <TrackersHost />
                </ComparisonProvider>
              </AuthProvider>
            </I18nProvider>
          </ConsentProvider>
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
